import { render, staticRenderFns } from "./NewsFeatureGroups.vue?vue&type=template&id=49c897da"
import script from "./NewsFeatureGroups.js?vue&type=script&lang=js&external"
export * from "./NewsFeatureGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports